module.exports = __webpack_public_path__ + "a3f90dc5247dab1bb2064daccff182b5.MP3";